import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const SoftPlayPackages = () => {
  const packages = [{
    id: '01',
    name: 'Tiny Tot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4WktozD23sUFeswQq2cCuq/77BCF6CB-EA89-44A4-BDDF-18A46698D723-1024x768.jpg',
    features: ['Medium Bounce House', 'Colorful Puzzle Mats (12ft x 10ft)', '3 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gate'],
    price: '$325'
  }, {
    id: '02',
    name: 'Mega Tot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bj3F22sb2nuKqenpirTHh1/IMG_4577-1024x768.jpg',
    features: ['Combo Bounce House w/ ball pit', 'Colorful Puzzle Mats (16ft x 14ft)', '4 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Caterpillar Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$375'
  }, {
    id: '03',
    name: 'Gigantatot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/71zAVFXd9bzmKmHYJ4QCA8/image.png',
    features: ['Combo Bounce House w/ ball pit', 'Colorful Puzzle Mats (18ft x 16ft)', 'Medium Bounce House w/ Slide', '6 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Caterpillar Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$450'
  }];
  return <div className="bg-white w-full" data-id="element-709">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-710">
        {/* Page Title Section */}
        <div className="text-center mb-16" data-id="element-711">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-712">
            Colorful Soft Play Packages
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-713">
            Vibrant and engaging play areas perfect for active toddlers.
          </p>
        </div>
        {/* Package Cards Section */}
        <div className="space-y-8" data-id="element-714">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100" data-id="element-715">
              <div className="flex flex-col md:flex-row" data-id="element-716">
                {/* Package Image */}
                <div className="md:w-1/2 relative" data-id="element-717">
                  <img src={pkg.image} alt={`${pkg.name} Package`} className="w-full h-full object-cover" data-id="element-718" />
                </div>
                {/* Package Details */}
                <div className="p-8 md:w-1/2" data-id="element-719">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-720">
                    <span className="text-primary-500" data-id="element-721">{pkg.id}</span> -{' '}
                    {pkg.name}
                  </h2>
                  <ul className="space-y-3 mb-8" data-id="element-722">
                    {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-723">
                        <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-724" />
                        <span data-id="element-725">{feature}</span>
                      </li>)}
                  </ul>
                  <div className="mt-auto text-center" data-id="element-726">
                    <span className="text-4xl font-bold text-green-800" data-id="element-727">
                      {pkg.price}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* Call to Action */}
        <div className="mt-16 text-center" data-id="element-728">
          <Link to="/contact" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-secondary-500 hover:bg-primary-600 transition" data-id="element-729">
            Book Your Play Experience
          </Link>
        </div>
      </div>
    </div>;
};